<div>
  <div class="avs-red-line"></div>
  <div class="avs-white-line"></div>
  <div class="d-flex justify-content-between avs-footer px-2">
    <div class="mt-1 d-none d-lg-block d-xl-block">
      <a class="avs-footer-link" routerLink="/impressum">Impressum</a>
      <span> | </span>
      <a class="avs-footer-link" routerLink="/privacy">Datenschutz</a>
      <span> | </span>
      <a class="avs-footer-link" href="https://www.avs-verkehrssicherung.de/allgemeine-geschaeftsbedingungen" target="_blank">AGB</a>
      <!--<span> | </span> -->
      <!--<a class="avs-footer-link" href="#">Cookie-Einstellungen</a> -->
      <!--<span> | </span> -->
      <!--<a class="avs-footer-link"
        (mouseover)="isMouseOverIcon = true"
        (mouseleave)="isMouseOverIcon = false" routerLink="faq">
        <img [src]="isMouseOverIcon ? 'assets/icons/question-circle_red.svg' : 'assets/icons/question-circle_white.svg'" alt="Q&A Icon">
      </a> -->
    </div>
    <div class="d-block d-lg-none d-xl-none">
      <div class="position-relative mt-1">
        <img class="avs-menu-icon" src="assets/icons/list_lightgrey.svg"
            (click)="onFooterMenuButtonClicked()" alt="menu icon button" height="24">
        <div class="position-absolute avs-footer-small-menu-position">
          <avs-dropdown
                  *ngIf="isFooterMenuOpen"
                  [selectInput]="footerMenuSelectInput"
                  [isHeaderActive]="false"
                  (onItemClicked)="onMenuListItemClicked()">
          </avs-dropdown>
        </div>
      </div>
    </div>
    <div class="mt-1">
      Kontakt: opz&#64;avs.eu&nbsp;Tel:&nbsp;+49 2597 9608-24
    </div>
    <div class="mt-1">
      &copy; 2026 | AVS Verkehrssicherung GmbH
    </div>
  </div>
</div>
